import React from 'react';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';

import s from './WideWidgetLayout.scss';

export interface Props {
  header?: string;
  subSubheader?: string;
  navigation: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const WideWidgetLayout: React.FC<Props> = ({
  header,
  subSubheader,
  navigation,
  children,
  className,
}) => {
  const profile_mobile_heading = useFlag('profile_mobile_heading');
  // If header is supplied, we want to make sure all of this is wrapped in a section
  const ContentColumnComponent = header ? Section : 'div';

  return (
    <div
      className={classnames(
        s['root'],
        profile_mobile_heading && s['profile_mobile_heading'],
        className
      )}
    >
      <div className={s['navigation']}>{navigation}</div>
      <ContentColumnComponent className={s['content-column']}>
        {header && (
          <Heading className={s['header']}>
            <div>{header}</div>
          </Heading>
        )}
        {subSubheader && <div className={s['subheader']}>{subSubheader}</div>}
        <div className={s['widgets']}>{children}</div>
      </ContentColumnComponent>
    </div>
  );
};
WideWidgetLayout.displayName = 'WideWidgetLayout';

export default WideWidgetLayout;
